// extracted by mini-css-extract-plugin
module.exports = {"container":"Testimonials-module--container--gyiv9","content":"Testimonials-module--content--35Dqb","description":"Testimonials-module--description--1yGSy"};